export default function loadScript(initFunction: () => void): void {
  if (document.readyState !== 'loading') {
    initFunction();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', initFunction);
  } else {
    // dirty workaround
    (<any>document).attachEvent('onreadystatechange', function () {
      if (document.readyState === 'complete') {
        initFunction();
      }
    });
  }
}
